import React from 'react';

export default (props) => {
  const { orgInfo: [{ acronym, website, name }] } = props;
  const openLinkNewPage = (e) => {
    window.open(website, '_blank');
    e.preventDefault();
    e.stopPropagation();
  };
  return Boolean(website) ? (
  <div style={{ position: 'absolute', display: 'block', top: '8px', right: '4px', width: '29%', fontSize: '10px' }}>
    What is <a onTouchTap={openLinkNewPage}><span style={{
      display: 'inline-block',
      marginBottom: '-4px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '60px',
    }}
    >{acronym || name}</span></a> ?
  </div>
  ) : null;
};



// WEBPACK FOOTER //
// ./src/app/components/profile/memberships/addOrgLink.jsx